exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".overlay{display:flex;justify-content:center;align-items:center;z-index:9999999;padding:20px;position:absolute;top:0;right:0;bottom:0;left:0}.overlay.ng-enter.ng-enter-active,.overlay.ng-leave{opacity:1}.overlay.ng-enter,.overlay.ng-leave.ng-leave-active{opacity:0}.overlay.ng-leave{transition:.25s}", ""]);

